// Resolve API base URL at runtime so a single React build works on:
//   - Priority Command (same host as API)        -> window.__API_BASE_URL=""
//   - Dating/Talk/Hub (different platform host)   -> window.__API_BASE_URL="https://platform.com"
// Falls back to empty (relative) when no runtime config is set, which is the
// safe default for the all-in-one Priority Command install.
// The build-time REACT_APP_BACKEND_URL is only used during SSR/build.
const API_URL = (typeof window !== 'undefined')
  ? (typeof window.__API_BASE_URL === 'string' ? window.__API_BASE_URL : '')
  : (process.env.REACT_APP_BACKEND_URL || '');

export default API_URL;
